import TabContext from "@mui/lab/TabContext"
import TabList from "@mui/lab/TabList"
import TabPanel from "@mui/lab/TabPanel"
import { styled, Typography } from "@mui/material"
import Box from "@mui/material/Box"
import Tab from "@mui/material/Tab"
import { useState } from "react"
import { ClinicalDataTab } from "./Clinical/ClinicalDataTab"
import { WastewaterDataTab } from "./Wastewater/WastewaterDataTab"

const Content = styled("div")({
  marginTop: 20,
  background:
    "linear-gradient(180deg, #000000 50%, #1D2229 90%, transparent 100%);",
  padding: "12px 24px",
})

const TabPanelStyled = styled(TabPanel)({
  padding: "24px 0",
})

export const AdditionalDataSources = () => {
  const [value, setValue] = useState("1")

  return (
    <Content>
      <Typography variant="h2">Additional Data Sources</Typography>
      <Box sx={{ width: "100%", typography: "body1" }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={(_, newValue: string) => setValue(newValue)}
              aria-label="Additional data sources tabs"
            >
              <Tab label="Wastewater" value="1" />
              <Tab label="Medical Search Engine" value="2" />
              <Tab label="Clinical" value="3" />
              <Tab label="PHC Pulses" value="4" />
            </TabList>
          </Box>
          <TabPanelStyled value="1">
            <WastewaterDataTab />
          </TabPanelStyled>
          <TabPanelStyled value="2">Coming soon...</TabPanelStyled>
          <TabPanelStyled value="3">
            <ClinicalDataTab />
          </TabPanelStyled>
          <TabPanelStyled value="4">Coming soon...</TabPanelStyled>
        </TabContext>
      </Box>
    </Content>
  )
}
